// try to apply remaining defaults for rejected decisions
import {clearRejectedDecisions, decision} from '../slices/decisionsSlice';

export const rejectedDecisionsMiddleware = store => next => action => {
    const result = next(action);

    if (action.type === 'decisions/decisionsLoading/fulfilled') {
        if (store.getState().decisions.data.rejectedDecisions && store.getState().decisions.data.rejectedDecisions.length > 0) {
            store.getState().decisions.data.rejectedDecisions.forEach(feature => {
                const rejectedFeatureId = feature.variableId;
                const rejectedFeatureValueId = feature.featureValues[0].featureValueId;
                // console.log('rejected: ', rejectedFeatureId);
                const remainingDefaults = store.getState().productData.defaults.filter(defaultFeature => {
                    const key = defaultFeature.variableId + '.' + defaultFeature.featureValues[0].featureValueId;
                    return defaultFeature.variableId === rejectedFeatureId &&
                        defaultFeature.featureValues[0].featureValueId !== rejectedFeatureValueId &&
                        (key in store.getState().decisions.data.normalizedDecisions ? store.getState().decisions.data.normalizedDecisions[key].canBeIncluded : true);
                });
                remainingDefaults.forEach(remainingDefault => {
                    // dispatch decision
                    // console.log('dispatch remaining default: ', remainingDefault.variableId, remainingDefault.featureValues[0].featureValueId);
                    store.dispatch(decision(
                        {
                            variableId: remainingDefault.variableId,
                            featureValueId: remainingDefault.featureValues[0].featureValueId,
                            state: 'Included'
                        }
                    )).unwrap();
                });
            });
            store.dispatch(clearRejectedDecisions());
        }
    }
    return result;
};
